module.exports = __webpack_public_path__ + "img/03.f6ac1b7d.jpg";